<template>
  <div
    class="flex flex-col gap-y-4 divide-y-2 divide-dashed divide-los-blue-base bg-los-blue-lightest px-6 pt-4 pb-6 rounded-tl-md rounded-bl-md md:rounded-md min-h-full md:min-h-0 shadow font-normal"
  >
    <button
      v-if="canResetFilters"
      class="btn-blue px-6 mx-auto flex items-center text-sm"
      @click="onReset"
    >
      Reset alle filters
      <FontAwesome class="ml-1 text-base" icon="rotate-left" />
    </button>

    <div :class="{ 'pt-3.5': canResetFilters }">
      <legend class="text-xl text-los-blue-darkest mb-0.5 font-medium">
        Categorie
      </legend>
      <div
        class="flex items-center group pl-1.5 mb-0.5"
        v-for="(t, index) in types"
        :key="index"
      >
        <input
          :value="t.key"
          type="radio"
          :id="t.key"
          v-model="typeFilter"
          class="accent-[#208084]"
          :name="`type-${index}`"
          @change="(e) => onChange('type', e)"
        />
        <label
          class="ml-2 whitespace-nowrap"
          :class="{
            'text-los-blue-darkest underline font-medium': type === t.key,
            'group-hover:underline': type != t.key,
          }"
          :for="t.key"
          >{{ t.name }}</label
        >
      </div>
    </div>

    <div class="pt-3.5">
      <legend class="text-xl text-los-blue-darkest mb-0.5 font-medium">
        Merk
      </legend>
      <div
        class="flex items-center group pl-1.5 mb-0.5"
        v-for="(b, index) in brands"
        :key="index"
      >
        <input
          :value="b.key"
          type="radio"
          :id="b.key"
          v-model="brandFilter"
          class="accent-[#208084]"
          :name="`brand-${index}`"
          @change="(e) => onChange('brand', e)"
        />
        <label
          class="ml-2 transition-all"
          :class="{
            'text-los-blue-darkest underline font-medium': brand === b.key,
            'group-hover:underline': brand != b.key,
          }"
          :for="b.key"
          >{{ b.name }}</label
        >
      </div>
    </div>

    <div class="pt-3.5">
      <label
        class="block text-xl text-los-blue-darkest mb-2.5 font-medium"
        for="price-min"
      >
        (€) Laag
      </label>
      <div
        class="border border-gray-300 focus-within:border-los-blue-dark transition-all bg-white rounded-lg text-sm w-full"
      >
        <input
          id="price-min"
          v-model="priceLowFilter"
          type="text"
          placeholder="Bijv. €750"
          class="bg-transparent border-none outline-none w-full h-full p-2"
          @change="(e) => onChange('price_gte', e)"
        />
      </div>
    </div>

    <div class="pt-3.5">
      <label
        class="block text-xl text-los-blue-darkest mb-2.5 font-medium"
        for="price-max"
      >
        (€) Hoog
      </label>
      <div
        class="border border-gray-300 focus-within:border-los-blue-dark transition-all bg-white rounded-lg text-sm w-full"
      >
        <input
          id="price-max"
          v-model="priceHighFilter"
          class="bg-transparent border-none outline-none w-full h-full p-2"
          type="text"
          placeholder="Bijv. €6.000"
          @change="(e) => onChange('price_lte', e)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  types: {
    type: Array,
    default: null,
  },
  type: {
    type: String,
    default: 'alle-machines',
  },
  brands: {
    type: Array,
    default: null,
  },
  brand: {
    type: String,
    default: 'alle-merken',
  },
  priceLow: {
    type: String,
    default: null,
  },
  priceHigh: {
    type: String,
    default: null,
  },
  canResetFilters: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['onChange', 'onReset']);

const typeFilter = computed({
  get() {
    return props.type;
  },
  set(v) {
    return v;
  },
});

const brandFilter = computed({
  get() {
    return props.brand;
  },
  set(v) {
    return v;
  },
});

const priceLowFilter = computed({
  get() {
    return props.priceLow;
  },
  set(v) {
    return v;
  },
});

const priceHighFilter = computed({
  get() {
    return props.priceHigh;
  },
  set(v) {
    return v;
  },
});

function onChange(key, e) {
  const { value } = e.target;
  emit('onChange', { key, value });
}

function onReset() {
  emit('onReset');
}
</script>

<style lang="scss" scoped></style>
